/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import {
  defaultEmailForm,
  defaultPassword,
  initialState,
} from "./initialState";
import { IRegister } from "../../Auth/types";
import { defaultRegisterForm } from "../../Auth/redux/initialState";
import { INotificationList, IOrder, IOrderList } from "../types";

export const useClinicSlice = createSlice({
  name: "profileState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },

    updateRegisterFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `registerForm.${action.payload.key}`, action.payload.value);
    },

    clearRegisterFrom: (state) => {
      state.registerForm = { ...defaultRegisterForm };
    },
    setRegisterFromData: (state, action: PayloadAction<IRegister>) => {
      state.registerForm = action.payload;
    },

    doUpdateProfile: (
      state,
      action: PayloadAction<{ callback: () => void }>
    ) => {},
    doLogOut: (state) => {
      localStorage.removeItem("token");
    },
    updatePasswordFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `password.${action.payload.key}`, action.payload.value);
    },
    clearPasswordFrom: (state) => {
      state.password = { ...defaultPassword };
    },

    doGetUserProfile: (state) => {
      state.loading = true;
    },

    toggleShowPassword: (state) => {
      state.togglePassword = !state.togglePassword;
    },
    toggleConfirmPassword: (state) => {
      state.toggleConfirmPassword = !state.toggleConfirmPassword;
    },
    doUpdatePassword: (
      state,
      action: PayloadAction<{ callback: (token: string) => void }>
    ) => {},

    updateEmailFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `emailForm.${action.payload.key}`, action.payload.value);
    },
    doUpdateEmail: (
      state,
      action: PayloadAction<{ callback: (token: string) => void }>
    ) => {},
    clearEmailForm: (state) => {
      state.emailForm = { ...defaultEmailForm };
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },
    setTotalCount: (state, action: PayloadAction<number>) => {
      state.totalCount = action.payload;
    },

    setOrderDir: (state, action: PayloadAction<"asc" | "desc">) => {
      state.orderDir = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<string>) => {
      state.orderBy = action.payload;
    },
    setOrderList: (state, action: PayloadAction<IOrderList[]>) => {
      state.orderList = action.payload;
    },

    doGetOrderList: (state) => {
      state.loading = true;
    },
    
    doGetOrderById: (state, action: PayloadAction<string>) => {
      state.loading = true;
    },
    setOrderDetails: (state, action: PayloadAction<IOrder>) => {
      state.orderDetails = action.payload;
    },
    setNotificationList: (state, action: PayloadAction<INotificationList[]>) => {
      state.notificationList = action.payload;
    },
    doOrderCancel: (
      state,
      action: PayloadAction<{ id: string; callback: () => void }>
    ) => {},
    doOrderUpdate: (
      state,
      action: PayloadAction<{ id: string; callback: () => void }>
    ) => {},
    setPackageItemHold: (
      state,
      action: PayloadAction<{
        id: string;
        productId: string;
      }>
    ) => {
      const { id, productId } = action.payload;
      const index = state.holdUpdatedItems.findIndex((item) => item._id === id);
      if (index !== -1) {
        state.holdUpdatedItems.splice(index, 1);
      } else {
        state.holdUpdatedItems.push({
          _id: id,
          productId: productId,
        });
      }
    },
    doGetNotificationList: (state) => {
      state.loading = true;
    },
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
